import { ContentMetadata } from '@candu-ai/content/types';
import { SegmentBaseDefinition } from 'dashboard/pages/Segment/components';

import { Filter, FilterEnglishNames, FilterOperationsEnglishNames, FilterTypes } from './types';
import { isUserPropertyFilter } from './utils';

const getNameFromArray = (operand: string[] | string, items: any) => {
  if (typeof operand === 'object') {
    return operand
      .map((itemId) => {
        const foundItem = items.find((item: any) => item.id === itemId);
        return foundItem?.name || itemId;
      })
      .join(', ');
  }

  const foundItem = items.find((item: any) => item.id === operand);
  return foundItem?.name || operand;
};

export const getFiltersTag = (
  filter: Filter,
  contents: ContentMetadata[],
  segments: SegmentBaseDefinition[],
) => {
  if (filter.type === FilterTypes.ContentId) {
    const selectedContent = getNameFromArray(filter.operation.operand, contents || []);

    return `Content ${FilterOperationsEnglishNames[
      filter.operation.type
    ].toLowerCase()} ${selectedContent}`;
  }

  if (filter.type === FilterTypes.SegmentId) {
    const selectedSegment = getNameFromArray(filter.operation.operand, segments || []);

    return `Segment ${FilterOperationsEnglishNames[
      filter.operation.type
    ].toLowerCase()} ${selectedSegment}`;
  }

  if (isUserPropertyFilter(filter)) {
    return `${filter.traitName} ${FilterOperationsEnglishNames[
      filter.operation.type
    ].toLowerCase()} ${filter.operation.operand}`;
  }
  return `${FilterEnglishNames[filter.type]} ${FilterOperationsEnglishNames[
    filter.operation.type
  ].toLowerCase()} ${filter.operation.operand}`;
};
